import { Reducer, Action } from "redux";
import {
    ImyAccountState,
    KnownAction,
    GET_ACCOUNT_INFORMATION,
    GET_ACCOUNT_INFORMATION_LOADER,
    GET_SECURITY_QUESTIONS,
    GET_IS_IDF_USER,
    SET_IS_IDF_USER_LOADER,
    GET_FAMILY_OFFER,
    SET_FAMILY_OFFER_LOADER,
    SET_IS_BILLING_INFO_CHANGED,
} from "./types";

export const reducer: Reducer<ImyAccountState> = (state: ImyAccountState | undefined, incomingAction: Action): ImyAccountState => {
    if (state === undefined) {
        return {
            _unifiedAccountInfo: undefined,
            isLoading: false,
            isIdfUserLoading: false,
            familtOffer: undefined,
            isLoadingFamilyOffer: false,
            isBillingInfoChanged: false,
        };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case GET_ACCOUNT_INFORMATION:
            return {
                ...state,
                _unifiedAccountInfo: action._unifiedAccountInfo,
            };
        case GET_ACCOUNT_INFORMATION_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case GET_SECURITY_QUESTIONS:
            return {
                ...state,
                securityQueData: action.securityQueData,
            };
        case GET_IS_IDF_USER:
            return {
                ...state,
                isIdfUser: action.isIdfUser,
            };
        case SET_IS_IDF_USER_LOADER:
            return {
                ...state,
                isIdfUserLoading: action.isIdfUserLoading,
            };
        case GET_FAMILY_OFFER:
            return {
                ...state,
                familtOffer: action.familyOffer,
            };
        case SET_FAMILY_OFFER_LOADER:
            return {
                ...state,
                isLoadingFamilyOffer: action.isLoadingFamilyOffer,
            };
        case SET_IS_BILLING_INFO_CHANGED:
            return {
                ...state,
                isBillingInfoChanged: action.isBillingInfoChanged,
            };
        default:
            return state;
    }
};
